import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/Merienda-Regular.ttf'
import './fonts/Lato-Regular.ttf'
import './fonts/DancingScript.ttf'
import './fonts/Raleway-Regular.ttf'
import './fonts/Roboto-Regular.ttf'
import './styles/index.css';
import 'es7-object-polyfill'
import configureStore, {persistor } from './store/configureStore';
import Root from './containers/Root';
import * as serviceWorker from './serviceWorker';
import configureFirebase from "./config/firebase"


const store = configureStore();
configureFirebase()

ReactDOM.render(<Root store={store} persistor={persistor}/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
